// extracted by mini-css-extract-plugin
module.exports = {"image":"product-special-offer_image__1SJaT","imageContainer":"product-special-offer_imageContainer__LX_9s"};